/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-27 12:56:17
 *
 * LastModified: 2017-06-01 17:12:42
 *-------------------------------------------------------*/

import { take, call, put, fork, all } from 'redux-saga/effects';
import fetchApi from '../../../../../utils/fetchApi';

function* updateBillingTotalModel() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('UPDATE_BILLING_TOTAL_MODEL');
		try {
			const response = yield call(fetchApi, 'Billings/adminChangePlan', payload.data, { method: 'POST' });
			if (response && !response.error) {
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* getAllUsersFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload: { filter, clearState }, next } = yield take('GET_ALL_USERS');
		if (clearState) {
			yield put({ type: 'RESET_ALL_USERS_STATE' });
		}
		try {
			const response = yield call(fetchApi, `Accounts?filter=${JSON.stringify(filter)}`);
			if (response && !response.error) {
				yield put({ type: 'GET_ALL_USERS_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* exportUsersCSVFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { next } = yield take('EXPORT_USERS_CSV');
		try {
			const response = yield call(fetchApi, `users?filter={"fields": {"regId": false}, "order": "created DESC"}`);
			if (response && !response.error) {
				if (next && typeof next === 'function') {
					next(response.data);
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* editUserFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('EDIT_REQUEST');
		try {
			const response = yield call(fetchApi, `requests/${payload.id}`, payload.data, { method: 'PATCH' });

			if (response && !response.error) {
				yield put({
					type: 'EDIT_REQUEST_SUCCESS',
					payload: response
				});
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* editAllUsersFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('UPDATE_ALL_USERS');
		try {
			const curDate = new Date();
			curDate.setMonth(curDate.getMonth() + 1);
			const endContract = `${curDate.getFullYear()}${curDate.getMonth() + 1}${curDate.getDate()}`;

			const reqs = [];
			payload.map((el) => {
				reqs.push(call(fetchApi, 'users/role', { userId: el.id, roleName: el.type, endContract }, { method: 'POST' }));
				return el;
			});
			// console.log(reqs);

			const response = yield all(reqs);
			// console.log(response);
			if (response && response[0] && !response[0].error) {
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

export function* usersListFlow() {
	yield fork(getAllUsersFlow);
	yield fork(exportUsersCSVFlow);
	yield fork(editUserFlow);
	yield fork(editAllUsersFlow);
	yield fork(updateBillingTotalModel);
}



// WEBPACK FOOTER //
// ./routes/admin/routes/users/saga/list.js